// src/pages/Reset_password.jsx
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Axios from "axios";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import { toast } from "react-hot-toast";

export default function Reset_password() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      toast.error("Invalid or missing token.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    try {
      const payload = {
        token: token,
        new_password: newPassword,
      };

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/update_password_from_token`,
        payload
      );

      toast.success(response.data.message);
    } catch (error) {
      console.error("Reset password error:", error);
      toast.error(error.response?.data?.message || "Failed to reset password");
    }
  };

  return (
    <>
      <Header />
      <div className="bg-primary pt-5 pb-20">
        <div className="container">
          <div className="row">
            <h1 className="text-secondary fw-boldest point-42">
              Reset Password
            </h1>
          </div>
        </div>
      </div>
      <div className="bg-white py-3">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="card w-100 mt-n20 bg-white rounded-3 shadow-sm mb-5">
                <div className="card-body p-3">
                  <div className="d-flex flex-column justify-content-center align-items-center vh-50">
                    <h3 className="text-secondary fw-bolder point-16 text-uppercase mt-4">
                      Set New Password:
                    </h3>
                    <form onSubmit={handleSubmit} className="w-100 px-4 py-3">
                      <div className="mb-3">
                        <label className="form-label text-secondary fw-bold">
                          New Password
                        </label>
                        <input
                          type="password"
                          className="form-control border border-2 border-secondary rounded-2"
                          placeholder="Enter New Password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          required
                        />
                      </div>

                      <div className="mb-4">
                        <label className="form-label text-secondary fw-bold">
                          Confirm Password
                        </label>
                        <input
                          type="password"
                          className="form-control border border-2 border-secondary rounded-2"
                          placeholder="Confirm New Password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                        />
                      </div>

                      <div className="d-grid">
                        <button
                          type="submit"
                          className="btn btn-secondary rounded-pill fw-bold text-uppercase"
                        >
                          Save Changes
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
